<template>
<!-- Start Services Area
    ============================================= -->
    <div class="services-area bg-gray left-border default-padding bottom-less">
      <!-- Shape Fixed Rotation -->
      <div class="shape-fixed animation-rotation">
        <img src="assets/img/round-shappe.png" alt="Thumb" />
      </div>
      <!-- Dhape Fixed Rotation -->
      <div></div>
      <div class="container">
        <div class="heading-left">
          <div class="row">
            <div class="col-lg-5">
              <h2>
                Tenemos los servicios que necesitas para llevar tu negocio al
                espacio.
              </h2>
            </div>
            <div class="col-lg-6 offset-lg-1">
              <p>
                Que herramientas Utilizamos para ayudar a nuestros clientes?
              </p>
              <!-- <a class="btn circle btn-md btn-gradient wow fadeInUp" href="#">ver Todo <i class="fas fa-plus"></i></a>-->
            </div>
          </div>
        </div>
        <div class="services-items">
          <div class="row">
            <!-- Single Item -->
            <div class="feature-2-col-carousel owl-carousel owl-theme">
              <div class="item">
                <img src="assets/img/docker.png" alt="Thumb" />
                <h4>Dcokers</h4>
                <p>
                  Con esta gra y potente herramientas podemos optimizar
                  funciones y ahorrar costos, 100% escalable.
                </p>

                <div class="button">
                  <a class="btn-standard" href="#"
                    ><i class="fas fa-angle-right"></i>Leér más</a
                  >
                </div>
              </div>

              <div class="item">
                <img src="assets/img/icon/2.png" alt="Thumb" />
                <h4>Data Analytics</h4>
                <p>
                  El analisis de datos que tu negocio necesita, con reporteria
                  en la palma de tu mano.
                </p>
                <div class="button">
                  <a class="btn-standard" href="#"
                    ><i class="fas fa-angle-right"></i> Leer Más</a
                  >
                </div>
              </div>

              <!-- Single Item -->
              <!-- Single Item -->

              <div class="item">
                <img src="assets/img/icon/3.png" alt="Thumb" />
                <h4>Business Intelligence</h4>
                <p>La potencia de este concepto en tu negocio,</p>
                <div class="button">
                  <a class="btn-standard" href="#"
                    ><i class="fas fa-angle-right"></i> Read More</a
                  >
                </div>
              </div>
            </div>
            <!-- Single Item -->
            <!-- Single Item -->

            <!-- Single Item -->
          </div>
        </div>
      </div>
    </div>
    <!-- End Services Area -->
</template>


<script>
    export default {
        name: "Banner4",
        components: {},
        beforeMount() {},
    };
</script>